import * as React from 'react';
import type { SVGProps } from 'react';
const SvgYellowExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill={props.fill ? props.fill : '#FFD100'} fillRule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 9V3h2v6zm0 4v-2h2v2z" clipRule="evenodd" />
  </svg>
);
export default SvgYellowExclamation;
